import { authComponents_svSE } from "@ssf/auth-components";
import { components_svSE } from "@ssf/components";
import { playComponents_svSE } from "@ssf/play-components";
import i18next, { use } from "i18next";
import { merge } from "lodash";
import { initReactI18next } from "react-i18next";

import playWeb_svSE from "../locales/locale.sv-SE.json";

const svSE = merge(
  components_svSE,
  authComponents_svSE,
  playComponents_svSE,
  playWeb_svSE,
);

declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "common";
    resources: typeof playWeb_svSE;
  }
}

use(initReactI18next).init({
  lng: "svSE",
  fallbackLng: "svSE",
  defaultNS: "common",
  resources: { svSE },
  react: {
    useSuspense: true,
    transKeepBasicHtmlNodesFor: [
      "br",
      "strong",
      "i",
      "p",
      "em",
      "a",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "ul",
      "ol",
      "li",
    ],
  },
});

export { i18next };
